module.exports = __webpack_public_path__ + "images/88d2dcbcce248e168c935a03652f4b2f.png";